import { useEffect, useState } from 'react';
const isPageActive = () => {
    if (typeof window === 'undefined')
        return {};
    const { href } = window.location;
    const pages = [
        { path: 'https://www.olx.com.br', name: 'explore' },
        { path: 'https://conta.olx.com.br/chats', name: 'messages' },
        { path: 'https://www2.olx.com.br/desapega', name: 'desapegar' },
        { path: 'https://conta.olx.com.br/anuncios', name: 'ads' },
    ];
    const activePage = pages.find(({ path }) => href.includes(path));
    if (activePage) {
        return { [activePage.name]: true };
    }
    return {};
};
export const usePageActive = () => {
    const [pageActive, setPageActive] = useState({});
    const handleToggleAccount = () => {
        setPageActive((prevState) => (Object.assign(Object.assign({}, (prevState.account && isPageActive())), { account: !prevState.account })));
    };
    useEffect(() => {
        const activePage = isPageActive();
        if (activePage) {
            setPageActive(activePage);
        }
    }, []);
    return { pageActive, handleToggleAccount };
};
